import script from "./ProColorUpsell.vue?vue&type=script&setup=true&lang=js"
export * from "./ProColorUpsell.vue?vue&type=script&setup=true&lang=js"

import "./ProColorUpsell.vue?vue&type=style&index=0&id=a3e066f8&lang=scss"

const __exports__ = script;

export default __exports__